import { Injectable, inject } from "@angular/core";
import {Store} from "@ngrx/store";
import {Router, UrlTree} from "@angular/router";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";

@Injectable({
  providedIn: 'root'
})
export class LinkPropertiesGuard {
  private _store = inject(Store);
  private _router = inject(Router);


  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    return this._store.select(
      SharedLoginSelectors.selectHasLinkFeature(f => f.isShowingProperties),
    ).pipe(
      map((canActivate) => canActivate ? true : this._router.createUrlTree([`not-allowed`]))
    );
  }
}
